interface ResponsiveSectionProps {
  mobile?: React.ReactNode;
  web?: React.ReactNode;
}

export const ResponsiveSection = ({ mobile, web }: ResponsiveSectionProps) => {
  return (
    <>
      {mobile && <div className="md:hidden">{mobile}</div>}
      {web && <div className="max-md:hidden">{web}</div>}
    </>
  );
};
